import PropertyNotificationSettings from './PropertyNotificationSettings.vue';

export default PropertyNotificationSettings;
